const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/meridian`;

async function request(path, { method = "GET", body } = {}) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let data;
  try { data = text ? JSON.parse(text) : {}; } catch { data = { raw: text }; }
  if (!res.ok) throw Object.assign(new Error(data?.detail?.error || `HTTP ${res.status}`), { status: res.status, data });
  return data;
}

export const api = {
  health: () => request("/health"),
  verticals: () => request("/verticals"),
  overview: () => request("/overview"),
  reset: () => request("/demo/reset", { method: "POST" }),

  entities: () => request("/entities"),
  entity: (id) => request(`/entities/${id}`),
  onboardEntity: (body) => request("/entities", { method: "POST", body }),

  accounts: () => request("/accounts"),
  openAccount: (body) => request("/accounts", { method: "POST", body }),
  createObligation: (body) => request("/obligations", { method: "POST", body }),
  transfer: (body) => request("/transfers", { method: "POST", body }),

  policies: () => request("/policies"),
  simulate: (body) => request("/decisions/simulate", { method: "POST", body }),
  decisions: () => request("/decisions"),

  entries: () => request("/ledger/entries"),
  bankTransactions: () => request("/ledger/bank-transactions"),

  runRecon: (body = {}) => request("/reconciliation/run", { method: "POST", body }),
  reconRuns: () => request("/reconciliation/runs"),
  reconExceptions: () => request("/reconciliation/exceptions"),
  resolveException: (id, body = {}) => request(`/reconciliation/exceptions/${id}/resolve`, { method: "POST", body }),

  killSwitch: () => request("/kill-switch"),
  setKillSwitch: (body) => request("/kill-switch", { method: "POST", body }),

  capitalOffers: (entityId) => request(`/capital/offers?entity_id=${entityId}`),
  underwrite: (body) => request("/capital/underwrite", { method: "POST", body }),

  audit: () => request("/audit"),
  verifyAudit: () => request("/audit/verify"),

  examPacks: () => request("/exam-pack"),
  generateExamPack: (body = {}) => request("/exam-pack", { method: "POST", body }),
  examPack: (id) => request(`/exam-pack/${id}`),

  drill: (body = {}) => request("/reconstruction-drill", { method: "POST", body }),
};

export const money = (cents) =>
  (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 });

export const shortId = (id) => (id ? `${id.slice(0, 8)}` : "—");
